import { createFeatureSelector } from '@ngrx/store';
import { MY_BOOKING_STORE_NAME, MyBookingState } from './my-booking.state';

/** Select MyBooking State */
export const selectMyBookingState = createFeatureSelector<MyBookingState>(MY_BOOKING_STORE_NAME);
